import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';

@Component({
  selector: 'app-login-payment',
  templateUrl: './login-payment.component.html',
  styleUrls: ['./login-payment.component.css']
})
export class LoginPaymentComponent implements OnInit {

  @Output() eventLoggedIn = new EventEmitter();
  @Output() eventRegister = new EventEmitter();
  @Output() eventRegisterAsGuest = new EventEmitter();
  @Output() eventBack = new EventEmitter();

  @Input()
  fullSize: boolean;

  @Input()
  showBack: boolean;

  @Input()
  showGuestRegister = true;

  @Input()
  showRegistrationUrl = true;

  @Input()
  email: string;

  @Input()
  readOnlyEmail: boolean;

  @Input()
  showRememberMe = true;

  @ViewChild('loginComponent', { static: true }) loginComponent;

  constructor() { }

  ngOnInit(): void {
  }

  onLoggedIn(): void {
    this.eventLoggedIn.emit();
  }

  onRegister(): void {
    this.eventRegister.emit();
  }

  onRegisterAsGuest(): void {
    this.eventRegisterAsGuest.emit();
  }

  onBack(): void {
    this.eventBack.emit();
  }
}
